var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_79012",
    "data-name": "Group 79012",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146323",
    "data-name": "Rectangle 146323",
    width: 44,
    height: 44,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements",
    transform: "translate(8.685 8.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79007",
    "data-name": "Group 79007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62031",
    "data-name": "Path 62031",
    d: "M24.966,6.658H1.664A1.666,1.666,0,0,1,0,4.993V1.664A1.666,1.666,0,0,1,1.664,0h23.3a1.666,1.666,0,0,1,1.664,1.664V4.993A1.666,1.666,0,0,1,24.966,6.658ZM1.664,1.11a.555.555,0,0,0-.555.555V4.993a.555.555,0,0,0,.555.555h23.3a.555.555,0,0,0,.555-.555V1.664a.555.555,0,0,0-.555-.555Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79008",
    "data-name": "Group 79008",
    transform: "translate(8.877 9.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62032",
    "data-name": "Path 62032",
    d: "M24.089,15.658H9.664A1.666,1.666,0,0,1,8,13.993V10.664A1.666,1.666,0,0,1,9.664,9H24.089a1.666,1.666,0,0,1,1.664,1.664v3.329A1.666,1.666,0,0,1,24.089,15.658ZM9.664,10.11a.555.555,0,0,0-.555.555v3.329a.555.555,0,0,0,.555.555H24.089a.555.555,0,0,0,.555-.555V10.664a.555.555,0,0,0-.555-.555Z",
    transform: "translate(-8 -9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79009",
    "data-name": "Group 79009",
    transform: "translate(0 9.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62033",
    "data-name": "Path 62033",
    d: "M3.329,15.658a3.329,3.329,0,1,1,3.329-3.329A3.333,3.333,0,0,1,3.329,15.658Zm0-5.548a2.219,2.219,0,1,0,2.219,2.219A2.221,2.221,0,0,0,3.329,10.11Z",
    transform: "translate(0 -9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79010",
    "data-name": "Group 79010",
    transform: "translate(0 19.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62034",
    "data-name": "Path 62034",
    d: "M16.089,24.658H1.664A1.666,1.666,0,0,1,0,22.993V19.664A1.666,1.666,0,0,1,1.664,18H16.089a1.666,1.666,0,0,1,1.664,1.664v3.329A1.666,1.666,0,0,1,16.089,24.658Z",
    transform: "translate(0 -18)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_79011",
    "data-name": "Group 79011",
    transform: "translate(19.973 19.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62035",
    "data-name": "Path 62035",
    d: "M21.329,24.658a3.329,3.329,0,1,1,3.329-3.329A3.333,3.333,0,0,1,21.329,24.658Zm0-5.548a2.219,2.219,0,1,0,2.219,2.219A2.221,2.221,0,0,0,21.329,19.11Z",
    transform: "translate(-18 -18)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponents);
export default __webpack_public_path__ + "static/media/Components.f24cabbbcd03a8db529d56f9deee68e0.svg";
export { ForwardRef as ReactComponent };